<template>
    <select class="form-control" ref="select"  multiple="multiple" :disabled="options.length === 0">
        <option v-for="(option, i) in mappedOptions" :value="option.value" :key="`${option.label}-${i}`">{{option.label}}</option>
    </select>
</template>

<script>

import $ from 'jquery';
import 'select2';

export default {
    name: 'mdb-multi-select',
    mounted() {
        const vm = this;

        vm.select = $(vm.$refs.select).select2({ 
            closeOnSelect: vm.closeOnSelect
        });

        vm.select.on('change', (e) => {
            vm.newValue = vm.select.select2('data').map((item) => {
                return item.id;
            }) || [];
        });

        vm.select.on("select2:unselect", (e) => {
            if (!e.params.originalEvent) {
                return;
            }

            e.params.originalEvent.stopPropagation();
        });

    },
    computed: {
        mappedOptions() {
            if(this.options.length === 0) {
                return this.options;
            }
            
            return this.options.map((option) => {
                return {
                    label: option[this.label || 'label'],
                    value: option[this.valueField || 'value']
                }
            });
        },
        newValue: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    data() {
        return {
            select: null
        }
    },
    props: {
        value: {
            type: Array,
            default: () => {
                return [];
            }
        },
        options: {
            type: Array,
            default: () => {
                return [];
            },
            validator: function (value) {
                // The value must match one of these strings
                return value.length === 0 || typeof(value[0]) === 'object';
            }
        },
        label: {
            type: String
        },
        valueField: {
            type: String
        },
        closeOnSelect: {
            type: Boolean,
            default: false
        }
    }
}
</script>